import {NumberIDFolder, StringIDFolder} from 'constants/FolderConstants';

// TODO(T2222): Remove
export default function normalizeFolder(folder: NumberIDFolder | StringIDFolder): StringIDFolder {
  return {...folder, id: (folder.api_identifier || folder.id) as string};
}
